export enum CompanyPageQueryParam {
  Action = 'action',
}
